import { render, staticRenderFns } from "./index.vue?vue&type=template&id=017cb624"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('017cb624')) {
      api.createRecord('017cb624', component.options)
    } else {
      api.reload('017cb624', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=017cb624", function () {
      api.rerender('017cb624', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/class/evaluations/vipEvaluateClass/index.vue"
export default component.exports